import Api from './api';

export const getAll = async () => { 
  let data = []
  await Api.get("/satisfactionsurveyquestionstype/getall")
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

